import React, {Component} from 'react';
import {  Link } from 'react-router-dom';
import { Button } from "@mui/material";
import axios from 'axios';
import { globalConfig } from "../../config/config";

export default class CreateVCSLabel extends Component {

	constructor(props)
	{
		console.log(props);
    	super(props);
  	}

  state = {
    vcsLabels : []
  };

	componentDidMount() 
	{
		this.handleOnLoad();
	}

	handleOnLoad = () => {
      axios.get(`${globalConfig.apiDatahubUrl}/vcs-labels/`, globalConfig.hardcoded_header).then(res => {
      const vcsVersions = res.data;
      console.log(vcsVersions);
      this.setState({ vcsVersions });
      console.log(res.data[0]);
		});
		
	}
	
	render(){
    return (
    <>
	<form>		
		<div class="container-fluid">
		<h4>Create A Label</h4>
		<hr />
				<div class="form-group row">
					<label class="ContentTitle col-sm-2">Version Label</label>
					<input class="form-control input-xlarge col-sm-8" id="versionLabel" 
							value="#{ombVcsLabelForm.createVcsLabel.versionLabel }" >
					</input>
				</div>
				<div class="form-group row">
					<label class="ContentTitle col-sm-2">Version Label Expiration Date</label>
					<input class="form-control input-medium date-picker col-sm-8" id="versionLabelExpTimestamp"
							value="#{ombVcsLabelForm.createVcsLabel.versionLabelExpTimestamp }"
						 >
					</input>
				</div>
		<hr />			
		<button value="Create Label" class="btn btn-success" actionListener="#{ombVcsLabelForm.create }" >Create Label</button>
		&nbsp;
		<Link to="/waves">
			<Button variant="contained" color="primary">
				Go Back
			</Button>
		</Link>
		</div>
	</form>
	</>
);
}
}
